var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgLockedFilled = function SvgLockedFilled(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#A9B2BD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.5H8.5C7.94772 11.5 7.5 11.9477 7.5 12.5V16C7.5 16.5523 7.94772 17 8.5 17H15.5C16.0523 17 16.5 16.5523 16.5 16V12.5C16.5 11.9477 16.0523 11.5 15.5 11.5Z",
    fill: "#394657"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9398 8.43934C11.2211 8.15804 11.6027 8 12.0005 8C12.3983 8 12.7798 8.15804 13.0611 8.43934C13.3425 8.72064 13.5005 9.10218 13.5005 9.5V10.5H10.5005V9.5C10.5005 9.10218 10.6585 8.72064 10.9398 8.43934ZM8.50049 10.5V9.5C8.50049 8.57174 8.86924 7.6815 9.52561 7.02513C10.182 6.36875 11.0722 6 12.0005 6C12.9287 6 13.819 6.36875 14.4754 7.02513C15.1317 7.6815 15.5005 8.57174 15.5005 9.5V10.5C16.6048 10.5003 17.5 11.3956 17.5 12.5V16C17.5 17.1046 16.6046 18 15.5 18H8.5C7.39543 18 6.5 17.1046 6.5 16V12.5C6.5 11.3954 7.39543 10.5 8.5 10.5H8.50049ZM14.5005 12.5H9.50049H8.5V16H15.5V12.5H14.5005Z",
    fill: "#394657"
  })));
};
var Memo = /*#__PURE__*/memo(SvgLockedFilled);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-icons/icons/LockedFilled.f2f9733517174390ac3bb06981a78f13.svg";